import * as React from 'react';

interface TagProps {
  value?: string;
  border?: boolean;
  maxWidth?: number;
  size?: 'small' | 'medium' | 'large';
  variant?: 'default' | 'success' | 'primary' | 'secondary' | 'tertiary' | 'quaternary' | 'danger';
  mode?: 'rounded' | 'rect' | null;
  padding?: boolean;
  color?: string;
  textColor?: string;
  className?: string;
  children?: React.ReactNode;
}

const Tag: React.FC<TagProps> = ({
  value,
  border = false,
  maxWidth,
  size = 'medium',
  variant = 'default',
  mode = 'rounded',
  padding = false,
  color,
  textColor,
  className = '',
  children,
}) => {
  const classes = getTagClasses(size, variant, border, mode as 'rounded' | 'rect', padding);

  const style: React.CSSProperties = {
    ...(color && { backgroundColor: color }),
    ...(textColor && { color: textColor }),
    ...(maxWidth && { maxWidth: `${maxWidth}px` }),
  };

  return (
    <div className={`${classes} ${className}`.trim()} style={style}>
      {value || children}
    </div>
  );
};

const getTagClasses = (
  size: string,
  variant: string,
  border: boolean,
  mode: 'rounded' | 'rect' | null,
  padding: boolean,
): string => {
  return [
    'pdq-tag',
    `pdq-tag--${size}`,
    `pdq-tag--${variant}`,
    border ? 'borderd' : '',
    mode === 'rect' ? 'pdq-tag--rect' : '',
    padding ? 'padding' : '',
  ]
    .filter(Boolean)
    .join(' ');
};

export default Tag;
